import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EpdkErrorPage } from './error.page';


@NgModule({
  imports: [CommonModule],
  declarations: [EpdkErrorPage],
  exports: [EpdkErrorPage]
})
export class EpdkErrorPageModule { }